import { createContext, useContext } from 'react';

const ChapterContext = createContext({});

export const { Provider: ChapterProvider } = ChapterContext;

export const useChapterContext = () => useContext(ChapterContext);
